import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

export function MuiPickersProvider(props) {
  return <MuiPickersUtilsProvider utils={MomentUtils} {...props} />;
}
